import { Children } from "react";

const appConfig = {
    "pages": [
        {
            "path": ["/flights-async","/flights/dynamic-async"],
            "modules": [
                {
                    module: 'ProductFilterFlightSearchPageAsync',
                    sort_index: 1,
                },
            ],
            "name": "Flight Search Async",
            "type": "searchResultPage",
            "layout": "default",
            "seo": {
                "title": "",
                "desc": ""
            }
        },
        {
            "id": "blog-category",
            "seo": {
                "desc": "",
                "title": ""
            },
            "name": "Blog Category Page",
            "path": [
                "/blog/category/:slug"
            ],
            "type": "blogCategoryPage",
            "layout": "default",
            "modules": [
                {
                    "module": "BlogCategoryPageInstance",
                    "sort_index": 1
                }
            ]
        },
        {
            "id": "blog-post",
            "seo": {
                "desc": "",
                "title": ""
            },
            "name": "Blog Post Page",
            "path": [
                "/blog/:slug"
            ],
            "type": "BlogPostPage",
            "layout": "default",
            "modules": [
                {
                    "module": "BlogPostPageInstance",
                    "sort_index": 1
                }
            ]
        }
    ],
    "modulesConfigs": {
        "BlogCategoryPageInstance": {
            "modules": "BlogCategoryPage",
        },
        "BlogPostPageInstance": {
            "modules": "BlogPostPage",
        },
        "ProductFilterFlightSearchPageAsync": {
            "module": "SwitchDatePicker",
            'searchOptions':['flights'],
            "backgroundImg": "/assets/images/sky360/main-back.jpg",
            "useAsyncSearch": true,
            "showSearchResults":{
                isActive:true
            },
            "theme":{
                "primary":"#0a2a59",
                "secondary":"#53cff7",
                'tertiary':"#7d7f8b"
            }
        }
    }
};
export default appConfig;